import transform from '../../utils/ResponseTransformator'
import mapResponseToTemplates from './mappers/mapResponseToTemplates'

export default function fetchTemplates(api: GlobalFetch) {
  return async function() {
    const buildUrl = `/api/v2/misc/templates/mode/0`
    const response = await api.fetch(buildUrl)
    let text: string = await response.text()
    text = transform(text)
    const responseBody: IData = JSON.parse(text)

    return mapResponseToTemplates(responseBody)
  }
}

export interface IData {
  messages: string[]
  items: IItemData[]
}

export interface IItemData {
  id: number
  id_user: number
  language: string
  type_title: string
  id_type: number
  id_status: number
  title: string
  content: string
  position: string
  created_at: number
  updated_at: number
}
